import React, { FC } from 'react';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

// const ConsentBanner: FC<WithOptimizelyProps> = () => {
//     const ssiPath = '/__universal/consent-banner.html';

//     return (
//         <div
//             data-testid="consent-banner"
//             dangerouslySetInnerHTML={{
//                 __html: `<!--# block name="consent-banner_fallback" --><!--# endblock --><!--# include virtual="${ssiPath}" stub="consent-banner_fallback" -->`
//             }}
//         />
//     );
// };

/**
 * 03-Mar-21: Despite not running any variants with Optimizely at the time of
 * commit there is a plan to introduce a rebranded version of the banner in the
 * very near future. Keeping Optimizely also keeps us consistent with the other
 * Universal SSI components (header and footer).
 */
// export default withOptimizely(ConsentBanner);

import htmlRebrand from './assets/rebrand.html.txt';

/**
 * 12-Mar-21: To help diagnose a production issue with nginx SSI we are
 * directly inlining the html and script snippets here
 */
const TemporaryHardCodedInclude: FC = () => {
    if (process.env.NODE_ENV !== 'production') return null;

    return (
        <>
            <div
                data-testid="consent-banner"
                dangerouslySetInnerHTML={{
                    __html: htmlRebrand.replace(
                        '{{segmentID}}',
                        publicRuntimeConfig.SEGMENT_ID
                    )
                }}
            />
        </>
    );
};

export default TemporaryHardCodedInclude;
